import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { addIcons } from 'ionicons';
import {
  addCircleOutline,
  copyOutline,
  openOutline,
  searchOutline,
  checkmarkOutline,
  closeCircleOutline,
  informationCircleOutline,
  alertCircleOutline,
  checkmarkCircleOutline,
  logoGoogle,
  locationOutline,
  checkmarkCircle
} from 'ionicons/icons';

// Register icons with kebab-case keys (only icons used in studio app)
addIcons({
  'add-circle-outline': addCircleOutline,
  'copy-outline': copyOutline,
  'open-outline': openOutline,
  'search-outline': searchOutline,
  'checkmark-outline': checkmarkOutline,
  'close-circle-outline': closeCircleOutline, // from shared dismissable-alert
  'information-circle-outline': informationCircleOutline, // from shared dismissable-alert + getUpdateMessageIcon
  'alert-circle-outline': alertCircleOutline, // from getUpdateMessageIcon
  'checkmark-circle-outline': checkmarkCircleOutline, // from getUpdateMessageIcon
  'logo-google': logoGoogle, // from shared google-sign-in-button
  'location-outline': locationOutline, // from create-map component
  'checkmark-circle': checkmarkCircle // from create-map component
});

// Prevent debug tokens in deployed environments (allow on localhost)
const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const allowDebugToken = environment.useAppCheckDebugToken || isLocalhost;

if (!allowDebugToken) {
  Object.defineProperty(window, 'FIREBASE_APPCHECK_DEBUG_TOKEN', {
    get: () => null,
    set: (val) => console.debug('[App Check] Prevented setting debug token:', val),
    configurable: true,
  });

  localStorage.removeItem('firebase:debugAppCheckToken');
  console.debug('[App Check] Explicitly neutralized AppCheck debug token in deployed environment.');
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

